export default (duration, callback) => {
  const then = Date.now();
  let id;

  const update = () => {
    const now = Date.now();
    const progress = (now - then) / duration;

    if (progress >= 1) {
      callback(1); // eslint-disable-line standard/no-callback-literal
    } else {
      id = requestAnimationFrame(update);
      callback(progress);
    }
  };
  id = requestAnimationFrame(update);

  return () => cancelAnimationFrame(id);
};
